import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import { Location } from '@angular/common';
import {Router} from '@angular/router';
import * as $ from '../assets/js/jquery.js';
import {ParamService} from "./shared/services/param.service";
import {AuthService} from "./shared/services/auth.service";
import {GoogleAdManagerService} from "./shared/services/google-ad-manager.service";
import {BannerUnitProps} from "./shared/models/bannerUnits.model";
import {environment} from "../environments/environment";
import {RewardsSummaryService} from "./shared/services/rewards-summary.service";

function _window(): any {
    return window;
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
    private adaFlag = false;
    private ClearAda = true;
    public hideUCALeftNav = false;
    private _routerSub;
    public isLanding = false;
    displayBanner: any;
    myList = false;
    partnerLanding = false;
    freshPassLanding = false;
    travelLanding = false;
    public currentEnvironment: string;
    banner: string;
    endemicGAMAdsLoaded = false;
    isWebView = false;
    public googleAdFlags: {
        endemicGAMAds: boolean,
        bottomAd: boolean
    } = {
        endemicGAMAds: false,
        bottomAd: true
    };
    public googleAdConfig: any;
    public sideBannerUnitProps: BannerUnitProps = {
        pageName: 'rewards',
        position: 'bottom'
    };
    @HostListener('keyup', ['$event'])
    keyUp(event: KeyboardEvent) {
        if (!this.adaFlag && event.key === 'Tab') {
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').addClass('ada-focus');
            this.adaFlag = true;
        }
    }

    @HostListener('window:click', ['$event'])
    onClick(event: MouseEvent) {
        if (this.adaFlag || this.ClearAda) {
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').removeClass('ada-focus');
            this.adaFlag = this.ClearAda = false;
        } else if ($(event.target).hasClass('ada-focus')) {
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').removeClass('ada-focus');
            this.adaFlag = false;
        }
    }

    constructor(private location: Location, private router: Router, private paramService: ParamService, private _rewardSummaryService: RewardsSummaryService, private authService: AuthService, readonly googleAdManagerService: GoogleAdManagerService) {
        this.deleteCookie('_elevaate_session_id', '');
    }

    deleteCookie = (name, domain) => document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;

    getWebViewStatus() {
        if (window.location.href.indexOf('mobile') > 0 || window.location.href.indexOf('partners-landing') > 0) {
            return true;
        } else {
            return false;
        }
    }

    ngOnInit() {
        this.isWebView = this.getWebViewStatus();
        this.currentEnvironment = this._rewardSummaryService.getEnvironment();
        this.googleAdConfig = environment[this.currentEnvironment].googleAdConfig;
        this.banner = this.paramService.banner;
        this.initiateNonEndemicAdds();
        const hideLeftNavRoutes = ['/points-history', 'reward-details', 'point-reward-detail', 'get-your-rewards', '/partner-detail', '/mobile-partner-detail', 'expedia'];
        this.displayBanner = this.paramService.displayBanner;
        this._routerSub = this.router.events.subscribe((events) => {
            if (events && events['url']) {
                const url = events['url'];
                if (url.indexOf('/points-history') >= 0 || url.indexOf('/reward-details') >= 0 || url.indexOf('/point-reward-details') >= 0 || url.indexOf('/get-your-rewards') >= 0 || url.indexOf('/partner-detail') >= 0 || url.indexOf('/mobile-partner-detail') >= 0 || url.indexOf('/expedia') >= 0) {
                    if(url.indexOf('/expedia') >= 0) {
                        this.travelLanding = true;
                    }
                    this.isLanding = true;
                } else {
                    this.isLanding = false;
                }
                if (url.toLowerCase().indexOf('?mylist'.toLowerCase()) >= 0) {
                    this.myList = true;
                } else {
                    this.myList = false;
                }
                if(url.indexOf('?freshpass') >= 0) {
                    this.freshPassLanding = true;
                }else{
                    this.freshPassLanding = false;
                }
                if(url.indexOf('/partner') >= 0) {
                    this.partnerLanding = true;
                } else {
                    this.partnerLanding = false;
                }
                for (const route of hideLeftNavRoutes) {
                    if (url.indexOf(route) >= 0) {
                        this.hideUCALeftNav = true;
                        break;
                    } else {
                        this.hideUCALeftNav = false;
                    }
                }
                window.scrollTo(0, 0);
            }
        });
    }
    initiateNonEndemicAdds() {
        if(this.googleAdConfig && this.googleAdConfig.displayAds) {
            this.googleAdFlags.bottomAd = this.googleAdConfig.displayAds.bottomAd;
        }
        this.loadGPTScript();
        setTimeout(() => this.loadGoogleADs(), 5000);
    }

    backtoRewardsLanding(event: Event) {
        event.preventDefault();
        // if (this.myList) {
        //     window.location.href = '/mylist.html';
        // } else if(this.freshPassLanding) {
        //     localStorage.removeItem('partnerDetails');
        //     window.location.href = '/freshpass/manage/confirmation';
        // } else if (this.partnerLanding) {
        //     localStorage.removeItem('partnerDetails');
        //     window.location.href = '/rewards/partners';
        // }else{
        //     window.location.href = '/rewards/dashboard';
        // }
        if(localStorage.getItem('partnerDetails') !== null) {
            localStorage.removeItem('partnerDetails');
        }
        this.location.back();
    }

    ngOnDestroy() {
        this._routerSub.unsubscribe();
    }

    public callGoogleAdManager() {
        // const googleAdConfig = environment.googleAdConfig;
        //non-endemic bottom Google AD
        if(this.googleAdFlags.bottomAd) {
            if(this.googleAdConfig.adBanners) {
                // let googleAdBanner;
                const banner = this.banner ? this.banner : window['AB'].userInfo.banner;
                if(window['AB'] && window['AB'].userInfo && window['AB'].userInfo.clubCard) {
                    const ccnId = {'ccn_sid': window['AB'].userInfo.clubCard}
                    this.googleAdConfig.rewardsAdBottom.targeting.push(ccnId);
                }
                let isAdoVidAdded: boolean = false;
                const oneTrustLoadedEvent = window['dataLayer'] && window['dataLayer'].find(x => x.event === 'OneTrustGroupsUpdated');
                isAdoVidAdded = oneTrustLoadedEvent && oneTrustLoadedEvent?.['OnetrustActiveGroups'] === ",C0001,";
                if(!isAdoVidAdded && window['AB'] && window['AB'].COMMON && window['AB'].COMMON.getCookie('AMCV_A7BF3BC75245ADF20A490D4D@AdobeOrg')) {
                    const amcv = window['AB'].COMMON.getCookie('AMCV_A7BF3BC75245ADF20A490D4D@AdobeOrg').split('|');
                    if(amcv) {
                        const ado_vid = {'ado_vid' : amcv[amcv.indexOf('MCMID')+1]};
                        this.googleAdConfig.rewardsAdBottom.targeting.push(ado_vid);
                    }
                }
                this.googleAdConfig.rewardsAdBottom.targeting[2].store = window['AB'].userInfo.j4u ? window['AB'].userInfo.j4u.storeId : window['AB'].userInfo.storeId;
                if(window['AB'].userInfo.preferenceMode) {
                    const userChannel = this.getChannelCode(window['AB'].userInfo.preferenceMode.toLowerCase());
                    const fc = ({fc :userChannel});
                    this.googleAdConfig.rewardsAdBottom.targeting.push(fc);
                }

                //Adding banner name dynamically to adUnitPath
                this.googleAdConfig.rewardsAdBottom.adUnitPath = this.googleAdConfig.rewardsAdBottom.adUnitPath.replace(/\{banner\}/g, banner);
                this.googleAdManagerService.loadAdXAds(this.googleAdConfig.rewardsAdBottom);
            }
        }
    }


    public getChannelCode(channel): string {
        const channelCodes = {
            instore: 'INS',
            delivery: 'DEL',
            pickup: 'PUP',
            dug: 'PUP',
            j4u: 'INS'
        }
        return channelCodes[channel];
    }
    public loadGoogleADs() {
        this.googleAdManagerService.initGoogleAdManager();
        this.callGoogleAdManager();
    }
    public loadGPTScript() {
        const head = <HTMLDivElement>document.head;
        const script = document.createElement('script');
        script.innerHTML = '';
        script.src = `https://pagead2.googlesyndication.com/tag/js/gpt.js`;
        script.async = true;
        script.defer = false;
        script.onload = () => this.googleAdManagerService.gamScriptLoaded(true, this.banner);
        script.onerror = () => this.googleAdManagerService.gamScriptLoaded(false, this.banner);
        head.appendChild(script);
    }
}
